













































































































































































import axios, { AxiosError, AxiosResponse } from 'axios';
import Vue from 'vue';

import Loader from '../../components/Loader.vue';
import Navbar from '../../components/Navbar.vue';
import TextField from '../../components/TextField.vue';

import LoadingHelper from '../../utils/loadingHelper';
import validators from '../../utils/validators';

import { store } from '../../store';
import Utils from '../../Utils';
import { logout } from '../../utils/authUtils';

interface IResetPayload {
  password: string;
  token?: string;
  email?: string;
}

export default Vue.extend({
  name: 'Submission',
  components: {
    Loader,
    Navbar,
    TextField,
  },
  created() {
    axios
      // @ts-ignore
      .get(`${process.env.VUE_APP_API_URI}/api/auth/hasSetPassword`)
      .then(res => {
        this.hasSetPassword = res.data;
      });
  },
  data() {
    return {
      password: '',
      loadingPasswordReset: false,
      passwordHasReset: false,
      hasSetPassword: undefined,
    };
  },
  methods: {
    logout() {
      logout();
    },
    async resetPassword() {
      if (await !this.$validator.validate()) {
        Utils.toastError('Invalid password');
        return;
      }

      this.loadingPasswordReset = true;
      const timer = new LoadingHelper(1000);
      timer.onComplete = (res: AxiosResponse | AxiosError) => {
        this.loadingPasswordReset = false;
        if (res instanceof Error) {
          Utils.toastError(
            (res.response && res.response.data.message) ||
              'An error has occured'
          );
        } else if (res.status === 200) {
          this.password = '';
          this.passwordHasReset = true;
          Utils.toastSuccess('Password reset successfully');
        } else {
          Utils.toastError('An error has occurred');
        }
      };

      timer.onError = err => {
        this.loadingPasswordReset = false;
        Utils.toastError('An error has occurred');
      };

      timer.start();

      const payload: IResetPayload = {
        password: this.password,
      };

      if (this.resetToken && this.email) {
        payload.token = this.resetToken;
        payload.email = this.email;
      } else if (!store.state.isAuthenticated || !store.state.jwt) {
        Utils.toastError('An error has occurred. Please try again later.');
      }

      let req;

      try {
        req = await axios.post(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/auth/passwordreset`,
          payload
        );
      } catch (err) {
        req = err as AxiosError;
      }

      timer.complete(req);
    },
    validatePassword: validators.validatePassword,
  },
  props: {
    resetToken: {
      required: false,
      type: String,
    },
    email: {
      required: false,
      type: String,
    },
  },
});
